'use client';
import React from 'react';
import { ProgressProvider } from '@bprogress/next/app';

const Loader = ({ children }) => {
  return (
    <ProgressProvider
      height='4px'
      color='#f8bc16'
      options={{ showSpinner: true }}
      shallowRouting
    >
      {children}
    </ProgressProvider>
  );
};

export default Loader;
